{
  "unitSelect": {
    "unit": "Единицы измерения",
    "select": "Выбрать"
  },
  "popConfirm": {
    "confirm_delete_message": "Хотите удалить элемент?"
  },
  "select": {
    "unselect": "Не выбрано"
  },
  "queryBuilder": {
    "from": "От",
    "to": "До"
  }
}